import { css, injectGlobal } from '@emotion/css';
import { BackendWrap } from 'Shared/backend/BackendWrap';
import { Breadcrumbs } from 'Shared/backend/Breadcrumbs';
import { AboutTab } from 'Shared/backend/contact/AboutTab';
import { EmailsTab } from 'Shared/backend/contact/EmailsTab';
import { GeneralTab } from 'Shared/backend/contact/GeneralTab';
import { HoursTab } from 'Shared/backend/contact/HoursTab';
import { SocialsTab } from 'Shared/backend/contact/SocialsTab';
import { ThirdPartyServicesTab } from 'Shared/backend/contact/ThirdPartyServices';
import { IconColour } from 'Shared/backend/IconColour';
import { LinkOpen } from 'Shared/backend/icons/LinkOpen';
import { TabPanes } from 'Shared/backend/Tabs';
import { Theme, verticalStyle } from 'Shared/backend/Theme';
import { theme, ThemeProvider } from 'Shared/backend/ThemeProvider';
import { standardRules } from 'Shared/common/Sanitise';
import { PageProvider } from 'Shared/frontend/PageProvider';
import { mergeProps } from 'solid-js';
import { createStore } from 'solid-js/store';

//TODO share with EventPage + elsewhere? Most of these styles should be shared...
const topLine = () => css({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
	marginBottom: '1em'
});

const mainStyle = () => css({
	margin: '1em 0 3em 0'
});
const headingWrapStyle = () => css({
	display: 'flex',
	alignItems: 'center',
	gap: '0.5em',
});

const headingStyle = () => css({
	fontWeight: 600
});

//TODO seperate out. Put in ContactPage or put in theme 
export const tabStyle = () => css(theme().detailsPane, verticalStyle('1.5em'));

//TODO possibly move into Theme...
export const repeaterPaneStyle = (gap='0.8em') => css(verticalStyle(), {
	marginTop: '1em',
	marginLeft: '1em',
	gap: gap
});


export function ContactPage(props)
{
	injectGlobal([standardRules,{body:Theme.body}]);

	const [venue,setVenue] = createStore(props.venue);

	const venueProps:IVenueProps = mergeProps({
		page: props.page,
		venue: props.venue,
		docId:venue._id,
		store:venue,
		setStore:setVenue,
		location:[],
		permission:'edit'
	});

	const tabs = {
		general:	{label:'General', component:GeneralTab},
		emails:		{label:'Emails', component:EmailsTab},
		hours:		{label:'Hours', component:HoursTab},
		social:		{label:'Social Media', component:SocialsTab},
		thirdParty:	{label:'3rd Party Apps', component:ThirdPartyServicesTab},
		about:		{label:'About', component:AboutTab},
	};

	return (
		<ThemeProvider theme={Theme}>
			<PageProvider page={props.page}>
				<BackendWrap>
					<div class={topLine()}>
						<Breadcrumbs items={{
							Admin: '/admin',
							Contact: null
						}} />
					 </div>

					<main class={mainStyle()}>
						<div class={headingWrapStyle()}>
							<h2 class={headingStyle()}>Venue and Contact Info</h2>

							<a href='/contact' target='_blank'>
								<LinkOpen class={css(theme().linkIcon)} fill={IconColour.text} />
							</a>
						</div>

						<TabPanes tabs={tabs} tabProps={venueProps} clearBorder={true} />
					</main>
				</BackendWrap>
			</PageProvider>
		</ThemeProvider>
	);
}

